import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultValues", "disabled", "id", "name", "onSelect", "options", "UNSAFE_touchableProps", "useSelectorLogo", "testID", "values"];
import React from 'react';
import useUncontrolledProp from '@bubble-ui/hook-use-uncontrolled-prop';
import { useUniqueFormIdentifier } from '@bubble-ui/hook-use-unique-form-identifier';
import View from '@bubble-ui/primitive-view';
import BaseSelectorOptionsOption from '@bubble-ui/temp-base-selector-options-option';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { getIds } from './getIds';
var SelectorOptionsMulti = _ref => {
  var {
      defaultValues,
      disabled,
      id,
      name,
      onSelect,
      options,
      UNSAFE_touchableProps,
      useSelectorLogo,
      testID,
      values
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SelectorOptionsMulti',
    props,
    useInstead: 'UNSAFE_touchableProps',
    removalDate: 'v7.0.0'
  });
  var ids = getIds(id);
  var componentName = useUniqueFormIdentifier({
    name,
    fallbackName: 'SelectorOptionsMulti'
  });
  var [selectorValues, setSelectorValues] = useUncontrolledProp({
    prop: values,
    defaultProp: defaultValues || [],
    onChange: onSelect
  });
  return /*#__PURE__*/React.createElement(View, {
    id: ids.root
  }, options.map((option, index) => /*#__PURE__*/React.createElement(BaseSelectorOptionsOption, _extends({
    UNSAFE_touchableProps: UNSAFE_touchableProps,
    checkbox: true,
    useSelectorLogo: useSelectorLogo,
    id: ids.option(index),
    testID: testID,
    isChecked: selectorValues === null || selectorValues === void 0 ? void 0 : selectorValues.includes(option.value),
    onClick: (selectedValue, e) => {
      if (selectorValues !== null && selectorValues !== void 0 && selectorValues.includes(selectedValue)) {
        setSelectorValues(selectorValues.filter(v => v !== selectedValue), e);
      } else {
        setSelectorValues([...(selectorValues || []), selectedValue], e);
      }
    },
    key: "".concat(option.value, "-").concat(index),
    isLast: index + 1 === options.length,
    name: componentName
  }, option, props, {
    disabled: disabled || option.disabled
  }))));
};
SelectorOptionsMulti.displayName = 'SelectorOptionsMulti';
export default SelectorOptionsMulti;
//# sourceMappingURL=index.js.map